<script setup lang="ts">
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons'
import ContentLoader from "@/components/content-loader.vue";
import PageHeader from '@/components/page-header.vue'
import PageContent from '@/components/page-content.vue'
import DataTable from "@/components/data-table.vue";
import DataTableHeader from "@/components/data-table-header.vue";
import DataTableCell from "@/components/data-table-cell.vue";
import DataTablePagination from "@/components/data-table-pagination.vue";
import HeroSplashError from "@/components/hero-splash-error.vue";
import { useQuery } from '@tanstack/vue-query';
import { mainQueries } from '@/features/tariffs/queries';
import { navigateTo } from "@/helpers/routing";
import { usePageQueryParameter, usePageSizeQueryParameter } from "@/composables/query-parameters";

const page = usePageQueryParameter()
const pageSize = usePageSizeQueryParameter()
const { data, isLoading,isError} = useQuery(mainQueries.fetchAssetTariffDashboard({
  page,
  pageSize}))
</script>

<template>
  <PageHeader>
    <div class="d-flex align-items-center">
      <FontAwesomeIcon class="icon-style me-2" :icon="faQuestionCircle"></FontAwesomeIcon>
      <span>List of assets currently linked to a tariff that has not been updated.</span>
    </div>
  </PageHeader>

  <PageContent>
    <ContentLoader :loading="isLoading" variant="table">
      <HeroSplashError v-if="isError" />

      <template v-else>
        <DataTable
          :records="data?.records||[]">
          <template #headers>
            <DataTableHeader name="assetCode" :sort="false">Asset</DataTableHeader>
            <DataTableHeader name="projectName" :sort="false">Name</DataTableHeader>
            <DataTableHeader name="tariff" :sort="false">Tariff</DataTableHeader>
            <DataTableHeader name="yearOfTariff" :sort="false">Year of Tariff</DataTableHeader>
          </template>

          <template #record="{ record }">
            <DataTableCell>{{ record.assetCode }}</DataTableCell>
            <DataTableCell class="clickable" @click="navigateTo({ name: 'assets.settings', params: { assetCode: record.assetCode } })">
              {{ record.projectName }}
            </DataTableCell>
            <DataTableCell>{{ record.tariff }}</DataTableCell>
            <DataTableCell>{{ record.yearOfTariff }}</DataTableCell>
          </template>
        </DataTable>

        <DataTablePagination
          :total-records="data!.paging.totalRecords"
          :page-size="data!.paging.pageSize"
          @update:page-size="pageSize = $event"
          :page="data!.paging.page"
          @update:page="page = $event">
        </DataTablePagination>
      </template>
    </ContentLoader>
  </PageContent>
</template>

<style lang="scss">
@import "@/assets/variables";
  .clickable {
    cursor: pointer;
  }
  .icon-style {
    width: 30px;
    height: 30px;
    color: $yellow;
  }
</style>
